export function loadView(view) {
  return () =>
    import(/* webpackChunkName: "view-[request]" */ `@/views/${view}.vue`);
}

export function loadViewComponent(view, component) {
  return () =>
    import(
      /* webpackChunkName: "view-[request]" */
      `@/components/${view}/${component}.vue`
    );
}

// export function loadConversationView(view) {
//   return () =>
//     import( /* webpackChunkName: "view-[request]" */
//       `@/views/conversations/${ view }.vue`);
// }
// export function dashboardView(view) {
//   return () =>
//     import( /* webpackChunkName: "view-[request]" */
//       `@/views/admin/dashboard/${ view }.vue`)
// }
// export function userView(view) {
//   return () =>
//     import( /* webpackChunkName: "view-[request]" */
//       `@/views/user/${ view }.vue`)
// }
